<template lang="pug">
v-card(class="ma-2" @click="clicked")
    v-img(class="white--text align-end" height="200px" :src=" 'data:image/png;base64, ' + trip.PhotoData")
        v-card-title {{ trip.Name }}
        v-card-text {{ trip.CarUsed }}
</template>

<script>
export default {
    props: ["trip"],
    methods: {
        clicked() {
            this.$emit("clicked");
        }
    }
}
</script>